var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class ScriptFetch {
    static get(url) {
        return __awaiter(this, void 0, void 0, function* () {
            let validUrl;
            try {
                validUrl = new URL(url);
            }
            catch (_) {
                return undefined;
            }
            try {
                const response = yield fetch(validUrl.href, {
                    method: "GET",
                    mode: "cors",
                    cache: "no-cache",
                    credentials: "same-origin"
                });
                if (response.ok)
                    return undefined;
                return yield response.text();
            }
            catch (error) {
                console.error(error);
            }
            return undefined;
        });
    }
    static json(url) {
        return __awaiter(this, void 0, void 0, function* () {
            let validUrl;
            try {
                validUrl = new URL(url);
            }
            catch (_) {
                return undefined;
            }
            try {
                const response = yield fetch(validUrl.href);
                if (response.ok)
                    return undefined;
                return yield response.json();
            }
            catch (error) {
                console.error(error);
            }
            return undefined;
        });
    }
}
